import { render } from "./CreateGame.vue?vue&type=template&id=1d8da301"
import script from "./CreateGame.vue?vue&type=script&lang=js"
export * from "./CreateGame.vue?vue&type=script&lang=js"

import "./CreateGame.vue?vue&type=style&index=0&id=1d8da301&lang=css"
script.render = render

export default script